module.exports = __webpack_public_path__ + "img/endofnow.9c2c8220.png";